import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetPasswordComponent } from './set-password.component';
import { SetPasswordRoutingModule } from './set-password-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { NgxFormErrorModule } from '@partneradmin/feature/ngx-form-error';
import { TranslocoModule } from '@ngneat/transloco';
import { ToastModule } from 'primeng/toast';
import { UnauthWrapperModule } from '../unauth-wrapper/unauth-wrapper.module';

@NgModule({
  declarations: [SetPasswordComponent],
  imports: [
    CommonModule,
    SetPasswordRoutingModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    RippleModule,
    NgxFormErrorModule,
    TranslocoModule,
    ToastModule,
    UnauthWrapperModule,
  ],
})
export class SetPasswordModule {}
